export default __webpack_public_path__ + "static/media/unsubscribed.daba7214.svg";